// Toast-Overlay: zeigt die Meldungen aus dem Store rechts unten. Fehler bleiben stehen (mit
// Schließen-Knopf), Info/Erfolg blenden sich selbst aus. CI-Farben, ruhige Darstellung.

import type { JSX } from 'react';
import { useStore } from '../state/store';

const KIND_STYLES: Record<string, string> = {
  info: 'border-bf-border bg-bf-navy-light text-bf-white',
  success: 'border-bf-gold/50 bg-bf-navy-light text-bf-white',
  error: 'border-red-500/60 bg-bf-navy-light text-red-200',
};

export function Toasts(): JSX.Element {
  const { toasts, dismiss } = useStore();
  return (
    <div
      className="pointer-events-none fixed bottom-10 right-4 z-50 flex w-80 flex-col gap-2"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`pointer-events-auto flex items-start justify-between gap-3 rounded border px-3 py-2 text-sm shadow-lg ${KIND_STYLES[t.kind]}`}
        >
          <span className="break-words">{t.message}</span>
          <button
            type="button"
            aria-label="close"
            onClick={() => dismiss(t.id)}
            className="shrink-0 text-bf-muted hover:text-bf-white"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
